import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { LmsService } from "../../../service/lms-service";

const leadpost = (params) => () => {
    return new Promise((resolve, reject) => {
        LmsService.requestCallbackLead(params)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

const createCallbackRequest = (params, secureToken) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.createCallbackRequest(params, secureToken)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export {
    leadpost,
    createCallbackRequest
};
